import { classNames } from "@/lib/util";

import "./DeviationBar.scss";

type Props = {
    /** Current value (e.g. estimate/actual ratio). */
    value: number;
    /** Reference value; gray segment ends here, deviation is value vs this (e.g. 1 for ratio, 100 for %). */
    baseValue: number;
    /** Scale ceiling. */
    maxValue: number;
};

/**
 * Horizontal bar: gray up to min(value, baseValue), then red (value < base) or green (value > base).
 * Scale is 0..maxValue so all bars in a set are comparable.
 */
const DeviationBar = ({ value, baseValue, maxValue: maxValueProp }: Props) => {
    const low = Math.min(value, baseValue);
    const high = Math.max(value, baseValue);
    const maxValue = Math.max(maxValueProp, high);
    const scale = (x: number) => (x / maxValue) * 100;

    const baseWidthPercent = scale(low);
    const deviationWidthPercent = scale(high) - scale(low);
    const isAboveBase = value > baseValue;

    return (
        <div className="deviation-bar">
            {baseWidthPercent > 0 && (
                <div className="deviation-bar__segment" style={{ width: `${baseWidthPercent}%` }} />
            )}
            {deviationWidthPercent > 0 && (
                <div
                    className={classNames("deviation-bar__segment", {
                        "is-above-base": isAboveBase,
                        "is-below-base": !isAboveBase,
                    })}
                    style={{ width: `${deviationWidthPercent}%` }}
                />
            )}
        </div>
    );
};

export default DeviationBar;
